import { useLayoutEffect, useState } from "react";

// vb-metrics#38 owner ruling: a desktop screen (≥ 1200 × 700) shows the whole view in the screen height.
export const DESKTOP_FIT_QUERY = "(min-width: 1200px) and (min-height: 700px)";

const matches = (query: string): boolean => typeof window.matchMedia === "function" && window.matchMedia(query).matches;

export const useMediaQuery = (media: string): boolean => {
    const [desktop, setDesktop] = useState(() => matches(media));
    useLayoutEffect(() => {
        if (typeof window.matchMedia !== "function") return;
        const query = window.matchMedia(media);
        const onChange = (): void => setDesktop(query.matches);
        onChange();
        query.addEventListener("change", onChange);
        return () => query.removeEventListener("change", onChange);
    }, [media]);
    return desktop;
};

export const useDesktopFit = (): boolean => useMediaQuery(DESKTOP_FIT_QUERY);
